import axios, { AxiosResponse, CancelToken } from "axios"
import {
  articuloAdapter,
  articuloByFiltersAdapter,
  articuloContactoIdByFiltersAdapter,
} from "./Articulo.adapter"
import { ArticuloReadingDtoProps } from "./DTOs/ArticuloReadingDto"
import { GetArticulosByContactoQueryDtoProps } from "./DTOs/GetArticulosByContactoQueryDto"
import { GetArticulosByFiltersQueryDtoProps } from "./DTOs/GetArticulosByFiltersQueryDto"
import { GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps } from "./Schemas/GetArticulosByContactoQueryDtoIPagedEnumerable"
import { GetArticulosByFiltersQueryDtoIPagedEnumerableProps } from "./Schemas/GetArticulosByFiltersQueryDtoIPagedEnumerable"

export interface getArticulosParams {
  CategoriasId?: string[]
  Concepto?: string
  IsExportEnabled?: boolean
  NumeroReferencia?: string
  PrecioVentaLowerLimit?: number
  PrecioVentaUpperLimit?: number
  TipoArticulo?: number
  SortingCriteria?: string
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
  EsDeCompra?: boolean
}

export const getArticulosByFilter = async (
  queryParams?: getArticulosParams,
  cancelToken?: CancelToken
): Promise<GetArticulosByFiltersQueryDtoIPagedEnumerableProps> => {
  const { data }: { data: GetArticulosByFiltersQueryDtoIPagedEnumerableProps } =
    await axios.get(`/Articulo/by-filters`, {
      params: queryParams,
      cancelToken,
    })
  return {
    currentPage: data.currentPage,
    items: data.items?.map((asiento: GetArticulosByFiltersQueryDtoProps) =>
      articuloByFiltersAdapter(asiento)
    ),
    totalCount: data.totalCount,
  }
}

export const getArticulosContactByFilter = async ({
  queryParams,
  id,
}: {
  queryParams?: getArticulosParams
  id: string
}): Promise<GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps> => {
  const {
    data,
  }: { data: GetArticulosByContactoQueryDtoPropsIPagedEnumerableProps } =
    await axios.get(`/Articulo/contacto/${id}/by-filters`, {
      params: queryParams,
    })
  return {
    currentPage: data.currentPage,
    items: data.items?.map((asiento: GetArticulosByContactoQueryDtoProps) =>
      articuloContactoIdByFiltersAdapter(asiento)
    ),
    totalCount: data.totalCount,
  }
}

export const getArticuloById = async (
  id: string
): Promise<ArticuloReadingDtoProps> => {
  const { data } = await axios.get(`/Articulo/${id}`)
  return articuloAdapter(data)
}

export const postArticulo = async (requestBody: FormData) => {
  const resp = await axios.post("/Articulo/insert", requestBody, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return resp
}

export const putArticulo = async (requestBody: FormData) => {
  const resp = await axios.put("/Articulo/update", requestBody, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return resp
}

export const deleteArticuloById = async (
  id: string
): Promise<AxiosResponse> => {
  const resp = await axios.delete(`/Articulo/${id}`)
  return resp
}

export const deleteMultipleArticulos = async (
  ids: string[]
): Promise<AxiosResponse> => {
  const resp = await axios.delete(`/Articulo/bulk-delete-by-ids`, { data: ids })
  return resp
}
